import React, { Component } from 'react'

import { ActionButton } from 'components/Buttons/index'

import RefundModal from '../RefundModal'

class RefundButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      refundModalIsOpen: false
    }

    this.openRefundModal = this.openRefundModal.bind(this)
    this.closeRefundModal = this.closeRefundModal.bind(this)
  }

  openRefundModal () {
    this.setState({ refundModalIsOpen: true })
  }

  closeRefundModal () {
    this.setState({ refundModalIsOpen: false })
  }

  render () {
    if (this.props.invoice.status !== 'charged') {
      return null
    }

    if (this.state.refundModalIsOpen) {
      return (
        <RefundModal
          invoice={this.props.invoice}
          onClose={this.closeRefundModal}
        />
      )
    } else if (isSepaPayment(refundablePayment(this.props.invoice))) {
      return (
        <ActionButton
          txt='Refund'
          icon='refund white'
          disabled
          title='Refunds are not yet supported for SEPA payments'
        />
      )
    } else {
      return (
        <ActionButton
          user={this.props.user}
          permission='memberships.refund'
          txt='Refund'
          icon='refund white'
          onClick={this.openRefundModal}
        />
      )
    }
  }
}

// billing refunds the first accepted payment on the invoice
const refundablePayment = invoice =>
  (invoice.payments || []).find(payment => payment.status === 'accepted')

// billing-slimpay has no refund mechanism yet
const isSepaPayment = payment =>
  !!payment && (
    payment.provider_name === 'slimpay' ||
    (payment.payment_method && payment.payment_method.provider === 'slimpay')
  )

export default RefundButton
